
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { LoginApiService } from '../services/login-api.service';
import { SUB_TYPE, toasterMsg } from 'src/app/core/Constants/static';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {
  private user: UserProfile | null;
  public loginForm!: FormGroup;
  public get controls(): any { return this.loginForm.controls; }
  public submitted: boolean = false;
  public showPassword: boolean = false;
  public Forgot: boolean = false;
  public forgotForm!: FormGroup;
  public forgotSubmitted: boolean = false;
  public mailsuccess: boolean = false;
  public subTypes = SUB_TYPE
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  public dummyUserTypes: { id: number, name: string }[] = [
    {
      id: 1,
      name: 'ADMIN',
    }
  ]


  constructor(private router: Router,
    private loginapiservice: LoginApiService,
    private toasterandloader: ToasterService,
    private userService: UserService) {
    this.user = this.userService.getUserInfo();
  }

  public ngOnInit(): void {
    const payer = { id: 2, name: 'PAYER' };
    const provider = { id: 3, name: 'PROVIDER' }
    if (this.subTypeEvm == this.subTypes.payer) {
      this.dummyUserTypes.push(payer)
    } else if (this.subTypeEvm == this.subTypes.provider) {
      this.dummyUserTypes.push(provider)
    } else {
      this.dummyUserTypes = [...this.dummyUserTypes, payer, provider]
    }


    this.createLoginForm();
    this.forgotForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
    })
  }

  private createLoginForm(): void {
    this.loginForm = new FormGroup({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      userType: new FormControl(null, Validators.required)
    });
  }

  public userLogin(): void {
    this.submitted = true;
    let payload = {
      username: this.loginForm.value.username,
      password: this.loginForm.value.password,
      userType: this.loginForm.value.userType
    }
    if (this.loginForm.valid) {
      this.toasterandloader.isLoaderEnable(true);
      this.toasterandloader.isLogin(true);
      this.loginapiservice.userLogin(payload).subscribe({
        next: (response) => {

          if (response.status == 200) {

            const userProfile: UserProfile = {
              userDetails: response?.data.userDetails[0],
              accessToken: response?.data?.access_token,
              refreshToken: response?.data?.refresh_token
            }
            this.userService.setUserInfo(userProfile)
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.isLogin(false);
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: 'Login Successfully'
            })
            this.router.navigate(['/provider/payer']);

          } else {
            this.toasterandloader.alert.toast({
              title: 'Error',
              type: 'error',
              message: response?.message
            })
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.isLogin(false);
          }
        },
        error: (error) => {
          // treat error
          this.toasterandloader.isLoaderEnable(false);
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: "Failed to Login"
          });
        },
      })
    }
  }

  public selectedValue(event: string | null, formElem: string): void {
    if (!event) {
      this.loginForm.controls[formElem].patchValue(null);
    }
    this.loginForm.controls[formElem].patchValue(event);
  }

  public forgotPassword(): void {
    this.forgotSubmitted = true;
    if (this.forgotForm.valid) {
      let payload = {
        userName: this.forgotForm.value.email,
      }
      this.toasterandloader.isLoaderEnable(true);
      this.toasterandloader.isLogin(true);
      this.loginapiservice.forgot(payload).subscribe({
        next: (response) => {

          if (response.data) {
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.isLogin(false);
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: toasterMsg.forgotPasswordSuccess
            })
            this.mailsuccess = true;
            this.forgotForm.reset();
          } else {
            this.toasterandloader.alert.toast({
              title: 'Error',
              type: 'error',
              message: response?.message
            })
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.isLogin(false);
          }
        },
        error: (error) => {
          this.toasterandloader.isLoaderEnable(false);
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error?.message
          });
        },
      })
    }
  }

  public toggleForForgot(value: boolean): void {
    this.Forgot = value;
    this.submitted = false;
    this.forgotSubmitted = false;
    this.mailsuccess = false;
  }
}
